import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Collapse,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';
import moment from 'moment';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import NoResultsFound from '../../components/NoResultsFound';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const filterInitialValue = {
  FromDate: moment().startOf('month').format('YYYY-MM-DD'),
  ToDate: moment().format('YYYY-MM-DD'),
  Buyer: { BuyerId: 0, Buyer: 'All Buyers' },
  Factory: { AccId: 0, AccName: 'All Factories' },
  Style: { StyleNo: 'All Styles' },
  Po: {  OrderNo: 'All Po' },
  Year:moment().format('YYYY')
};

const FactoryOrderSheet = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [FactoryOrderSheets, setFactoryOrderSheets] = useState([]);
  const [filterStyles, setFilterStyles] = useState([]);
  const [filterPo,setFilterPo]=useState([])
  const [buyers, setBuyers] = useState([]);
  const [factories, setFactories] = useState([]);
  const [expanded, setExpanded] = useState(true);


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    getAllFactoryOrderSheet();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('ReferenceData/GetAllBuyers');
      const resData1 = await axios.get('ReferenceData/GetAllFactories');

      setBuyers(resData.data);
      setFactories(resData1.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  async function getAllFactoryOrderSheet() {
    try {
      showLoading();
      const response = await axios.post('Report/FactoryOrder/GetAllFactoryOrder', {
        FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
        StyleNo: filterData.Style.StyleNo === 'All Styles' ? '0' : filterData.Style.StyleNo,
        PoNo: filterData.Po.OrderNo === 'All Po' ? '0' : filterData.Po.OrderNo,
        Year: filterData.Year,
      });
      setFactoryOrderSheets(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const getStyleNo = async () => {
    try {
      if(filterData.Buyer.BuyerId === 0 || filterData.Factory.AccId === 0)   return;  
      const response = await axios.post('Report/FactoryOrder/GetStyles', {
        FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
      });
      setFilterData({...filterData, Style: { StyleNo: 'All Styles' },Po: { OrderNo: 'All Po' }});
      setFilterStyles(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    // hideLoading();
  };

  const getPo = async () => {
    try {
      if(filterData.Buyer.BuyerId === 0 || filterData.Factory.AccId === 0)   return;
      const response = await axios.post('Report/FactoryOrder/GetPo', {
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
        Year: filterData.Year,
      });
      
      setFilterPo(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    // hideLoading();
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  useEffect(() => {
    getPo();
    setFilterData({...filterData, Po: { OrderNo: 'All Po' }});
  }, [filterData.Year]);
  useEffect(() => {
    getStyleNo();
    getPo();
  }, [filterData.Buyer, filterData.Factory]);

  const filteredData = useMemo(() => {
    const newTableData = [...FactoryOrderSheets];
    if (page > 0) setPage(0);
    return newTableData;
  }, [FactoryOrderSheets, filterData]);

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [filteredData, page, rowsPerPage]);


  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Factory Order Sheet
            </Typography>
          </Typography>
        </Grid>
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded((expand) => !expand);
            }}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                  <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#8EACCD',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                <Grid item md={2} xs={12}>
                  {/* From Date */}
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={filterData.FromDate}
                    onChange={(e) => {
                      handleFilterDataChange('FromDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* To Date */}
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    name="ToDate"
                    value={filterData.ToDate}
                    onChange={(e) => {
                      handleFilterDataChange('ToDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    // error={!!formErrors.toDate}
                    // helperText={formErrors.toDate}
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ BuyerId: 0, Buyer: 'All Buyers' }, ...buyers]}
                    getOptionLabel={(buyers) => buyers.Buyer}
                    isOptionEqualToValue={(value) => value.BuyerId === filterData.Buyer?.BuyerId}
                    renderOption={(props, buyers) => (
                      <li {...props} key={buyers.BuyerId}>
                        {buyers.Buyer}
                      </li>
                    )}
                    value={filterData.Buyer}
                    name="Buyer"
                    onChange={(event, value) => {
                      handleFilterDataChange('Buyer', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Buyer" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ AccId: 0, AccName: 'All Factories' }, ...factories]}
                    getOptionLabel={(factory) => factory.AccName}
                    isOptionEqualToValue={(value) => value.AccId === filterData.Factory.AccId}
                    renderOption={(props, factory) => (
                      <li {...props} key={factory.AccId}>
                        {factory.AccName}
                      </li>
                    )}
                    value={filterData.Factory || null}
                    name="Factory"
                    onChange={(event, value) => {
                      handleFilterDataChange('Factory', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField  {...params} label="Factory" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{  StyleNo: 'All Styles' }, ...filterStyles]}
                    getOptionLabel={(styles) => styles.StyleNo}
                    isOptionEqualToValue={(value) => value.StyleNo === filterData.Style.StyleNo}
                    renderOption={(props, styles) => (
                      <li {...props} key={styles.StyleNo}>
                        {styles.StyleNo}
                      </li>
                    )}
                    value={filterData.Style || null}
                    name="Style"
                    onChange={(event, value) => {
                      handleFilterDataChange('Style', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Style No" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ OrderNo: 'All Po'},...filterPo]}
                    getOptionLabel={(order) => order.OrderNo}
                    isOptionEqualToValue={(value) => value.OrderNo === filterData.Po.OrderNo}
                    renderOption={(props, user) => (
                      <li {...props} key={user.OrderNo}>
                        {user.OrderNo} 
                      </li>
                    )}
                    value={filterData.Po || null}
                    name="Po"
                    onChange={(event, value) => {
                      handleFilterDataChange('Po', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Po No" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Year</InputLabel>
                    <Select
                      value={filterData.Year || ''}
                      name="Year"
                      size="small"
                      label="Year"
                      onChange={(event) => {
                        handleFilterDataChange('Year', event.target.value);
                      }}
                    >
                      {[-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5].map((value, i) => (
                        <MenuItem key={value} value={new Date().getFullYear() + value}>
                          {new Date().getFullYear() + value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      getAllFactoryOrderSheet();
                    }}
                    sx={{ boxShadow: 0 }}
                  >
                    View
                  </Button>
                 
                  {/* View Button */}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Collapse in={filteredData.length > 0}>
          <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
            <Table className="table-bordered" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">S.No</StyledTableCell>
                  <StyledTableCell align="left">Delivery Date</StyledTableCell>
                  <StyledTableCell align="left">Factory</StyledTableCell>
                  <StyledTableCell align="left">Buyer</StyledTableCell>
                  <StyledTableCell align="left">FOS NO</StyledTableCell>
                  <StyledTableCell align="center">Style</StyledTableCell>
                  <StyledTableCell align="center">Po No</StyledTableCell>
                  <StyledTableCell align="center">Order qty</StyledTableCell>
                  {/* <StyledTableCell align="center">Actions</StyledTableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : filteredData
                ).map((FactoryOrderSheet, i) => (
                  <TableRow key={FactoryOrderSheet.AssignId} hover>
                    <TableCell align="center">{FactoryOrderSheet.SNo}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.FOSDate}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.Factory}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.Buyer}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.FOSNo}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.StyleNo}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.OrderNo}</TableCell>
                    <TableCell align="left">{FactoryOrderSheet.OrderQty}</TableCell>

                    {/* <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(FactoryOrderSheet);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(FactoryOrderSheet.FactoryOrderSheetId);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell> */}
                  </TableRow>
                ))}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage} // Use the calculated currentPage value
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0); // Reset the page when rowsPerPage changes
            }}
            mt={2}
          />
        </Collapse>
        {!filteredData.length > 0 && <NoResultsFound />}
       
      </Container>
    </>
  );
};

export default FactoryOrderSheet;
